import * as React from "react"

const SvgReply = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m6.825 12.714 2.9 2.9q.3.3.287.7-.012.4-.312.7-.3.276-.7.288a.92.92 0 0 1-.7-.288l-4.6-4.6a.96.96 0 0 1-.3-.7q0-.4.3-.7l4.6-4.6a.93.93 0 0 1 .687-.275q.413 0 .713.275.3.3.3.713 0 .412-.3.712l-2.875 2.875H16q2.075 0 3.537 1.463Q21 13.64 21 15.714v3a.97.97 0 0 1-.288.713.97.97 0 0 1-.712.287.97.97 0 0 1-.713-.287.97.97 0 0 1-.287-.713v-3q0-1.25-.875-2.125A2.9 2.9 0 0 0 16 12.714z" />
  </svg>
)
export default SvgReply
